import { removeAlpha } from "./colourHelpers.js";
export const site = {
    50: "oklch(96.8% 0.006 239.82 / <alpha-value>)",
    100: "oklch(94.33% 0.01 247.94 / <alpha-value>)",
    200: "oklch(91.12% 0.017 248.02 / <alpha-value>)",
    300: "oklch(86.32% 0.026 248.13 / <alpha-value>)",
    400: "oklch(82.13% 0.034 248.24 / <alpha-value>)",
    500: "oklch(77.17% 0.044 247.31 / <alpha-value>)",
    600: "oklch(71.25% 0.056 247.76 / <alpha-value>)",
    700: "oklch(63.6% 0.072 248.37 / <alpha-value>)",
    800: "oklch(54.25% 0.076 248.79 / <alpha-value>)",
    900: "oklch(38.97% 0.052 250.26 / <alpha-value>)",
    950: "oklch(23.85% 0.026 248.99 / <alpha-value>)",
};
export const white = {
    50: "oklch(100% 0 0.002 / <alpha-value>)",
    100: "oklch(100% 0 0.002 / <alpha-value>)",
    200: "oklch(100% 0 0.002 / <alpha-value>)",
    300: "oklch(100% 0 0.002 / <alpha-value>)",
    400: "oklch(100% 0 0.002 / <alpha-value>)",
    500: "oklch(100% 0 0.002 / <alpha-value>)",
    600: "oklch(100% 0 0.002 / <alpha-value>)",
    700: "oklch(100% 0 0.002 / <alpha-value>)",
    800: "oklch(100% 0 0.002 / <alpha-value>)",
    900: "oklch(100% 0 0.002 / <alpha-value>)",
    950: "oklch(100% 0 0.002 / <alpha-value>)",
};
export const black = {
    50: "oklch(90% 0 0 / <alpha-value>)",
    100: "oklch(80% 0 0 / <alpha-value>)",
    200: "oklch(70% 0 0 / <alpha-value>)",
    300: "oklch(60% 0 0 / <alpha-value>)",
    400: "oklch(50% 0 0 / <alpha-value>)",
    500: "oklch(40% 0 0 / <alpha-value>)",
    600: "oklch(30% 0 0 / <alpha-value>)",
    700: "oklch(20% 0 0 / <alpha-value>)",
    800: "oklch(10% 0 0 / <alpha-value>)",
    900: "oklch(5% 0 0 / <alpha-value>)",
    950: "oklch(0% 0 0 / <alpha-value>)",
};
export const ocean = {
    50: "oklch(97.4% 0.037 192.45 / <alpha-value>)",
    100: "oklch(95.5% 0.066 191.43 / <alpha-value>)",
    200: "oklch(92.11% 0.121 189.47 / <alpha-value>)",
    300: "oklch(90.44% 0.15 187.52 / <alpha-value>)",
    400: "oklch(84.59% 0.148 186.11 / <alpha-value>)",
    500: "oklch(65.6% 0.114 187.3 / <alpha-value>)",
    600: "oklch(55.51% 0.097 186.51 / <alpha-value>)",
    700: "oklch(45.93% 0.08 186.63 / <alpha-value>)",
    800: "oklch(34.16% 0.059 188 / <alpha-value>)",
    900: "oklch(23.43% 0.041 186.67 / <alpha-value>)",
    950: "oklch(15.2% 0.026 190.08 / <alpha-value>)",
};
export const cyan = {
    50: "oklch(96.52% 0.016 226.97 / <alpha-value>)",
    100: "oklch(93.01% 0.033 226.31 / <alpha-value>)",
    200: "oklch(86.94% 0.061 226.24 / <alpha-value>)",
    300: "oklch(80.41% 0.091 227.74 / <alpha-value>)",
    400: "oklch(74.53% 0.116 229.28 / <alpha-value>)",
    500: "oklch(69.53% 0.133 232.36 / <alpha-value>)",
    600: "oklch(59.16% 0.117 233.86 / <alpha-value>)",
    700: "oklch(48.45% 0.094 233.04 / <alpha-value>)",
    800: "oklch(37.13% 0.069 231.74 / <alpha-value>)",
    900: "oklch(23.38% 0.04 230.85 / <alpha-value>)",
    950: "oklch(16.66% 0.024 221.12 / <alpha-value>)",
};
export const magenta = {
    50: "oklch(94.82% 0.027 350.88 / <alpha-value>)",
    100: "oklch(90.86% 0.05 350.67 / <alpha-value>)",
    200: "oklch(82.23% 0.1 352.49 / <alpha-value>)",
    300: "oklch(74.25% 0.153 355.25 / <alpha-value>)",
    400: "oklch(67.56% 0.199 358.17 / <alpha-value>)",
    500: "oklch(62.72% 0.231 2.91 / <alpha-value>)",
    600: "oklch(55.55% 0.216 5.83 / <alpha-value>)",
    700: "oklch(45% 0.174 5.1 / <alpha-value>)",
    800: "oklch(33.86% 0.129 3.86 / <alpha-value>)",
    900: "oklch(21.7% 0.078 0.55 / <alpha-value>)",
    950: "oklch(14.42% 0.048 354.71 / <alpha-value>)",
};
export const rose = {
    50: "oklch(94.02% 0.024 11.29 / <alpha-value>)",
    100: "oklch(88.97% 0.045 11.24 / <alpha-value>)",
    200: "oklch(77.36% 0.102 13.59 / <alpha-value>)",
    300: "oklch(67.67% 0.157 15.92 / <alpha-value>)",
    400: "oklch(59.6% 0.206 21.26 / <alpha-value>)",
    500: "oklch(51.78% 0.192 23.39 / <alpha-value>)",
    600: "oklch(43.69% 0.16 22.85 / <alpha-value>)",
    700: "oklch(36.26% 0.13 21.95 / <alpha-value>)",
    800: "oklch(27.36% 0.093 21.1 / <alpha-value>)",
    900: "oklch(18.92% 0.057 17.02 / <alpha-value>)",
    950: "oklch(13.05% 0.033 16.39 / <alpha-value>)",
};
export const sand = {
    50: "oklch(97.91% 0.004 91.45 / <alpha-value>)",
    100: "oklch(95.83% 0.007 88.64 / <alpha-value>)",
    200: "oklch(91.06% 0.016 86.43 / <alpha-value>)",
    300: "oklch(86.61% 0.022 83.26 / <alpha-value>)",
    400: "oklch(82.39% 0.03 82.58 / <alpha-value>)",
    500: "oklch(77.7% 0.039 84.56 / <alpha-value>)",
    600: "oklch(67.94% 0.057 85.49 / <alpha-value>)",
    700: "oklch(55.58% 0.053 84.22 / <alpha-value>)",
    800: "oklch(41.51% 0.038 82.35 / <alpha-value>)",
    900: "oklch(27.44% 0.022 88.02 / <alpha-value>)",
    950: "oklch(18.85% 0.011 80.5 / <alpha-value>)",
};
export const stone = {
    50: "oklch(96.21% 0.003 67.78 / <alpha-value>)",
    100: "oklch(93.05% 0.005 48.68 / <alpha-value>)",
    200: "oklch(86.03% 0.012 51.3 / <alpha-value>)",
    300: "oklch(77.97% 0.019 48.47 / <alpha-value>)",
    400: "oklch(70.79% 0.025 52.55 / <alpha-value>)",
    500: "oklch(63.34% 0.032 50.38 / <alpha-value>)",
    600: "oklch(53.79% 0.032 49.26 / <alpha-value>)",
    700: "oklch(43.66% 0.024 49.76 / <alpha-value>)",
    800: "oklch(34.16% 0.018 52.87 / <alpha-value>)",
    900: "oklch(22.68% 0.01 52.98 / <alpha-value>)",
    950: "oklch(15.77% 0.006 39.33 / <alpha-value>)",
};
export const rootbark = {
    50: "oklch(95.61% 0.003 67.78 / <alpha-value>)",
    100: "oklch(91.07% 0.007 80.72 / <alpha-value>)",
    200: "oklch(81.83% 0.014 67.63 / <alpha-value>)",
    300: "oklch(72.44% 0.022 72.06 / <alpha-value>)",
    400: "oklch(62.78% 0.03 72.6 / <alpha-value>)",
    500: "oklch(51.75% 0.026 71.48 / <alpha-value>)",
    600: "oklch(44.5% 0.022 69.88 / <alpha-value>)",
    700: "oklch(36.81% 0.018 74.12 / <alpha-value>)",
    800: "oklch(28.46% 0.012 67.33 / <alpha-value>)",
    900: "oklch(19.69% 0.007 78.16 / <alpha-value>)",
    950: "oklch(14.69% 0.004 49.25 / <alpha-value>)",
};
export const fire = {
    50: "oklch(95.93% 0.019 21.57 / <alpha-value>)",
    100: "oklch(92.02% 0.036 24.19 / <alpha-value>)",
    200: "oklch(83.29% 0.081 23.63 / <alpha-value>)",
    300: "oklch(75.94% 0.125 24.59 / <alpha-value>)",
    400: "oklch(68.64% 0.172 26.7 / <alpha-value>)",
    500: "oklch(63.24% 0.212 28.41 / <alpha-value>)",
    600: "oklch(56.63% 0.218 29.79 / <alpha-value>)",
    700: "oklch(46.32% 0.176 29.64 / <alpha-value>)",
    800: "oklch(34.58% 0.128 29.29 / <alpha-value>)",
    900: "oklch(22.82% 0.078 30.3 / <alpha-value>)",
    950: "oklch(15.54% 0.046 31.68 / <alpha-value>)",
};
export const sunset = {
    50: "oklch(96.93% 0.021 72.15 / <alpha-value>)",
    100: "oklch(94.63% 0.037 72.62 / <alpha-value>)",
    200: "oklch(89.5% 0.075 71.84 / <alpha-value>)",
    300: "oklch(84.1% 0.114 70.68 / <alpha-value>)",
    400: "oklch(79.61% 0.144 67.68 / <alpha-value>)",
    500: "oklch(75.42% 0.165 62.85 / <alpha-value>)",
    600: "oklch(66.08% 0.153 60.43 / <alpha-value>)",
    700: "oklch(53.31% 0.122 60.93 / <alpha-value>)",
    800: "oklch(40.89% 0.091 62.7 / <alpha-value>)",
    900: "oklch(26.36% 0.055 68.33 / <alpha-value>)",
    950: "oklch(17.49% 0.034 75.24 / <alpha-value>)",
};
export const lime = {
    50: "oklch(97.38% 0.019 125.81 / <alpha-value>)",
    100: "oklch(94.87% 0.037 125.22 / <alpha-value>)",
    200: "oklch(90% 0.078 126.06 / <alpha-value>)",
    300: "oklch(85.47% 0.11 126.84 / <alpha-value>)",
    400: "oklch(80.62% 0.144 127.79 / <alpha-value>)",
    500: "oklch(76.1% 0.174 129.58 / <alpha-value>)",
    600: "oklch(65.27% 0.15 129.43 / <alpha-value>)",
    700: "oklch(53.4% 0.121 129.4 / <alpha-value>)",
    800: "oklch(39.55% 0.086 128.82 / <alpha-value>)",
    900: "oklch(25.47% 0.048 127.88 / <alpha-value>)",
    950: "oklch(18.02% 0.029 127.4 / <alpha-value>)",
};
export const foliage = {
    50: "oklch(96.92% 0.045 162.49 / <alpha-value>)",
    100: "oklch(94.29% 0.087 160.74 / <alpha-value>)",
    200: "oklch(90.2% 0.164 157.36 / <alpha-value>)",
    300: "oklch(87.86% 0.223 152.34 / <alpha-value>)",
    400: "oklch(77.91% 0.215 149.95 / <alpha-value>)",
    500: "oklch(58.27% 0.159 150.28 / <alpha-value>)",
    600: "oklch(49.21% 0.132 151.14 / <alpha-value>)",
    700: "oklch(39.98% 0.106 151.49 / <alpha-value>)",
    800: "oklch(31.57% 0.081 153.33 / <alpha-value>)",
    900: "oklch(21.04% 0.051 156.05 / <alpha-value>)",
    950: "oklch(14.89% 0.032 162.38 / <alpha-value>)",
};
export const grass = {
    50: "oklch(96.56% 0.023 165.87 / <alpha-value>)",
    100: "oklch(93.84% 0.041 165.44 / <alpha-value>)",
    200: "oklch(88.13% 0.085 162.99 / <alpha-value>)",
    300: "oklch(82.26% 0.125 160.72 / <alpha-value>)",
    400: "oklch(77.44% 0.156 158.24 / <alpha-value>)",
    500: "oklch(68.84% 0.152 156.66 / <alpha-value>)",
    600: "oklch(58% 0.126 156.91 / <alpha-value>)",
    700: "oklch(46.94% 0.1 157.56 / <alpha-value>)",
    800: "oklch(36.52% 0.074 157.98 / <alpha-value>)",
    900: "oklch(23.83% 0.044 158.59 / <alpha-value>)",
    950: "oklch(16.19% 0.025 160.84 / <alpha-value>)",
};
export const deepocean = {
    50: "oklch(95.17% 0.026 239.07 / <alpha-value>)",
    100: "oklch(90.3% 0.052 242.16 / <alpha-value>)",
    200: "oklch(81.99% 0.099 242.62 / <alpha-value>)",
    300: "oklch(73.76% 0.146 244.82 / <alpha-value>)",
    400: "oklch(66.56% 0.185 250 / <alpha-value>)",
    500: "oklch(56.84% 0.168 251.53 / <alpha-value>)",
    600: "oklch(48% 0.139 250.8 / <alpha-value>)",
    700: "oklch(39.6% 0.113 250.2 / <alpha-value>)",
    800: "oklch(30.64% 0.084 248.52 / <alpha-value>)",
    900: "oklch(19.68% 0.048 243.35 / <alpha-value>)",
    950: "oklch(14.48% 0.029 231.23 / <alpha-value>)",
};
export const creativepurple = {
    50: "oklch(94.82% 0.01 311.18 / <alpha-value>)",
    100: "oklch(88.72% 0.023 308.17 / <alpha-value>)",
    200: "oklch(77.97% 0.046 307.12 / <alpha-value>)",
    300: "oklch(66.1% 0.073 306.76 / <alpha-value>)",
    400: "oklch(54.84% 0.098 306.78 / <alpha-value>)",
    500: "oklch(44.54% 0.078 306.45 / <alpha-value>)",
    600: "oklch(38.53% 0.065 307.14 / <alpha-value>)",
    700: "oklch(31.6% 0.05 305.81 / <alpha-value>)",
    800: "oklch(25.05% 0.037 305.58 / <alpha-value>)",
    900: "oklch(17.27% 0.017 307.34 / <alpha-value>)",
    950: "oklch(13.98% 0.012 303.86 / <alpha-value>)",
};
site.DEFAULT = site[50];
white.DEFAULT = white[500];
black.DEFAULT = black[900];
ocean.DEFAULT = ocean[500];
cyan.DEFAULT = cyan[500];
magenta.DEFAULT = magenta[500];
rose.DEFAULT = rose[500];
sand.DEFAULT = sand[500];
stone.DEFAULT = stone[500];
rootbark.DEFAULT = rootbark[500];
fire.DEFAULT = fire[500];
sunset.DEFAULT = sunset[500];
lime.DEFAULT = lime[500];
foliage.DEFAULT = foliage[500];
grass.DEFAULT = grass[500];
deepocean.DEFAULT = deepocean[500];
creativepurple.DEFAULT = creativepurple[500];
export const baseColours = {
    // Generated via https://www.tints.dev
    site,
    white,
    black,
    ocean,
    cyan,
    magenta,
    rose,
    sand,
    stone,
    rootbark,
    fire,
    sunset,
    lime,
    foliage,
    grass,
    deepocean,
    creativepurple,
    transparent: {
        500: "transparent",
        DEFAULT: "transparent",
    },
};
export const baseColoursNoAlpha = Object.fromEntries(Object.entries(baseColours).map(([name, varients]) => [
    name,
    Object.fromEntries(Object.entries(varients).map(([varient, value]) => [
        varient,
        removeAlpha(value),
    ])),
]));
//# sourceMappingURL=colourDefinitions.js.map